export enum ETipScheme {
    ABSOLUTE = 'ABSOLUTE',
    PERCENTAGE = 'PERCENTAGE'
}
